import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextLarge } from 'Packages/FacetDesign/Components';
import { BigPicklistInput } from 'Packages/FacetDesign/Components/BigPicklistInput';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';

export default buildFacetDesignOverride()
  .nameOverride('moduleName', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('primaryText', {
    _component: () => BodyTextLarge,
  }, overrideReadOnly)
  .nameOverride('secondaryText', {
    _component: () => BodyTextLarge,
  }, overrideReadOnly)
  .typeOverride('picklist', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly);
